import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="works-formats"
export default class extends Controller {

  static targets = ['button', 'editions']

  connect() {
  }

  toggle() {
    const svg = this.buttonTarget.querySelector('svg');
    svg.classList.toggle('spin');

    this.editionsTarget.classList.toggle('closed');

  }
}
